import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CurrentYearService {
  regExp = /\[currentYear\]/g;

  /**
   * currentYearParser replaces [currentYear] shortcodes with the current year as a string.
   * This allows content creators to insert a dynamic year that auto-updates without manual edits.
   *
   * @param {string} content - HTML content containing [currentYear] shortcodes
   * @return {string} - HTML content with the current year replacing each shortcode
   */
  currentYearParser = (content: string): string => {
    if (content && typeof content === 'string' && content.includes('[currentYear]')) {
      const currentYear = new Date().getFullYear().toString();
      return content.replace(this.regExp, currentYear);
    }

    return content;
  };
}
